<template>
  <div class="component-wrapper video d-flex pa-5">
    <v-progress-circular
      class="ma-auto"
      size="50"
      indeterminate
      color="primary"
      v-if="loader"
    ></v-progress-circular>

    <vueVimeoPlayer
      ref="player"
      :video-url="roomContent.openedContent"
      :controls="false"
      :options="vimeoOptions"
      v-show="!loader"
      @ready="onLoadVideo"
      @pause="onPause"
      :key="roomContent.openedContent"
    />
  </div>
</template>

<script>
  import { vueVimeoPlayer } from "vue-vimeo-player";
  import { mapMutations, mapState } from "vuex";

  export default {
    components: { vueVimeoPlayer },
    computed: {
      ...mapState({
        roomContent: (state) => state.school.roomContent,
        allowLeave: (state) => state.school.allowLeave,
        mediaUnlocked: (state) => state.school.mediaUnlocked
      }),
      loader() {
        return !this.isPlayerReady;
      },
    },
    data() {
      return {
        isPlayerReady: false,
        vimeoOptions: {
          muted: false
        }
      };
    },
    methods: {
      ...mapMutations(["setAllowLeave"]),
      onLoadVideo() {
        this.isPlayerReady = true;
        this.syncPlayback();
      },
      onPause() {
        console.log('guest: video onPause');
      },
      syncPlayback() {
        if (!this.mediaUnlocked) return;
        if (!this.isPlayerReady) return;
        if (!this.$refs.player) return;

        if (this.roomContent.videoPlaying) {
          console.log('guest: video play');
          this.$refs.player.play().catch((error) => { console.log(error) });
        } else {
          console.log('guest: video pause');
          this.$refs.player.pause();
        }
      }
    },
    watch: {
      'roomContent.hasSound'(val) {
        this.vimeoOptions.muted = !val;
      },

      'roomContent.videoPlaying'(playing) {
        this.syncPlayback();
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.allowLeave) {
        this.setAllowLeave(false);
        next();
      } else {
        next(false);
      }
    },
  };
</script>
